import { ChangeDetectionStrategy, Component, input } from '@angular/core';
// migrated 1:1 from @nexato/nx-core-module (#682)
import { IssueType } from '../../entities/issue/issue-type';

@Component({
    selector: 'app-issue-type-icon',
    template: `
        @switch (issueType()?.icon) {
            @case ('icon-damage') {
                <!-- Default issue icon -->
                <svg
                    viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: top;">
                    <g>
                        <g>
                            <path d="M8.04,12.38H3.34c-.28,0-.5-.23-.5-.5s.23-.5.5-.5h4.7c.28,0,.5.23.5.5s-.23.5-.5.5Z" fill="currentColor"/>
                            <path d="M8.04,10.58H3.34c-.28,0-.5-.23-.5-.5s.23-.5.5-.5h4.7c.28,0,.5.23.5.5s-.23.5-.5.5Z" fill="currentColor"/>
                        </g>
                        <path d="M4.84,6.83c-1.1,0-2-.9-2-2s.9-2,2-2,2,.9,2,2-.9,2-2,2ZM4.84,3.85c-.54,0-.99.44-.99.99s.44.99.99.99.99-.44.99-.99-.44-.99-.99-.99Z" fill="currentColor"/>
                        <path d="M8.83,15.94H3.31c-1.55,0-2.81-1.26-2.81-2.81V3.31C.5,1.76,1.76.5,3.31.5h9.69c1.62,0,2.94,1.32,2.94,2.94v4.63c0,.28-.23.5-.5.5s-.5-.23-.5-.5V3.44c0-1.06-.87-1.93-1.93-1.93H3.31c-.99,0-1.8.81-1.8,1.8v9.82c0,.99.81,1.8,1.8,1.8h5.52c.28,0,.5.23.5.5s-.23.5-.5.5Z" fill="currentColor"/>
                    </g>
                    <g>
                        <g>
                            <path d="M13.87,14.34c-.28,0-.5-.23-.5-.5v-1.47c0-.28.23-.5.5-.5s.5.23.5.5v1.47c0,.28-.23.5-.5.5Z" fill="currentColor"/>
                            <circle cx="13.87" cy="15.22" r=".6" fill="currentColor"/>
                        </g>
                        <path d="M13.87,17.5c-2,0-3.62-1.63-3.62-3.62s1.63-3.63,3.62-3.63,3.63,1.63,3.63,3.63-1.63,3.62-3.63,3.62ZM13.87,11.26c-1.44,0-2.62,1.17-2.62,2.62s1.17,2.62,2.62,2.62,2.62-1.17,2.62-2.62-1.17-2.62-2.62-2.62Z" fill="currentColor"/>
                    </g>
                </svg>
            }
            @case ('icon-ticket') {
                <!-- Settings/gear icon -->
                <svg
                    viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" style="vertical-align: top;">
                    <path d="M10.41,17.5h-2.83c-.48,0-.93-.35-1.04-.81l-.45-2.02-.54-.32-1.94.61c-.42.11-.84-.03-1.18-.37-.03-.03-.06-.07-.08-.11l-1.41-2.46c-.24-.36-.16-.92.2-1.28l1.51-1.4v-.67l-1.5-1.39c-.36-.36-.45-.84-.23-1.27l1.43-2.49s.05-.07.08-.11c.34-.34.76-.48,1.16-.38l1.94.66c.19-.13.38-.25.57-.35l.44-2.03c.12-.48.57-.83,1.05-.83h2.83c.48,0,.93.35,1.04.81l.45,2.02.54.33,1.94-.61c.43-.11.85.03,1.19.37.03.03.06.07.08.1l1.41,2.46c.24.36.16.92-.2,1.28l-1.51,1.4v.67l1.5,1.39c.36.36.45.85.23,1.27l-1.42,2.48s-.01.02-.02.04c0,.01-.01.02-.02.03-.29.38-.73.54-1.19.43h-.02s-.01,0-.02-.01l-1.9-.6c-.19.14-.39.25-.58.35l-.44,1.97c-.12.48-.57.83-1.05.83ZM5.62,13.29c.09,0,.18.02.26.07l.92.55c.12.07.2.19.23.32l.49,2.21,2.89.04.55-2.25s0-.02,0-.03c.02-.07.05-.13.1-.19.05-.05.1-.1.17-.13.01,0,.02-.01.04-.02.25-.1.52-.26.78-.47,0,0,.02-.02.03-.02.06-.04.13-.07.19-.08s.14-.01.21,0c.01,0,.03,0,.04.01l2.13.67s.08,0,.12-.04l1.4-2.43s0-.02-.04-.07l-1.65-1.52c-.1-.1-.16-.23-.16-.37v-1.11c0-.14.06-.27.16-.37l1.66-1.54s.03-.06.02-.07l-1.37-2.37c-.07-.06-.13-.09-.15-.07l-2.12.67c-.14.04-.29.03-.41-.05l-.92-.55c-.12-.07-.2-.19-.23-.32l-.49-2.21-2.89-.03-.55,2.31c-.04.16-.15.3-.31.36-.26.1-.53.27-.79.48-.13.11-.32.14-.48.08l-2.15-.74s-.04.03-.11.09l-1.38,2.39s0,.02.04.07l1.65,1.52c.1.1.16.23.16.37v1.11c0,.14-.06.27-.16.37l-1.66,1.54s-.03.06-.02.08l1.37,2.37c.07.06.13.08.16.07l2.12-.67s.1-.02.15-.02Z" fill="currentColor"/>
                    <g>
                        <g>
                            <path d="M9,9.46c-.28,0-.5-.23-.5-.5v-1.47c0-.28.23-.5.5-.5s.5.23.5.5v1.47c0,.28-.23.5-.5.5Z" fill="currentColor"/>
                            <circle cx="9" cy="10.35" r=".6" fill="currentColor"/>
                        </g>
                        <path d="M9,12.62c-2,0-3.62-1.63-3.62-3.62s1.63-3.63,3.62-3.63,3.63,1.63,3.63,3.63-1.63,3.62-3.63,3.62ZM9,6.38c-1.44,0-2.62,1.17-2.62,2.62s1.17,2.62,2.62,2.62,2.62-1.17,2.62-2.62-1.17-2.62-2.62-2.62Z" fill="currentColor"/>
                    </g>
                </svg>
            }
        }
    `,
    styles: [`
        svg {
            display: block;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssueTypeIconComponent {

    readonly issueType = input<IssueType>();

}